import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import HeroSection from './HeroSection';
import PillarsSection from './PillarsSection';
import SecurityProtocol from './SecurityProtocol';
import WhyUsSection from './WhyUsSection';
import Footer from './Footer';
import DiagnosticWizard from './DiagnosticWizard';

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openWizard = () => setWizardOpen(true);
  const closeWizard = () => setWizardOpen(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Helmet>
        <title>Auth0.Expert | Experts Migration Auth0 &amp; Sécurité IAM</title>
        <meta name="description" content="Auth0.Expert accompagne votre migration vers Auth0 : audit IAM, migration d'utilisateurs sans interruption et expertise OAuth 2.0. Diagnostic gratuit en 3 min." />
        <link rel="canonical" href="https://auth0.expert/" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://auth0.expert/" />
        <meta property="og:title" content="Auth0.Expert | Experts Migration Auth0 & Sécurité IAM" />
        <meta property="og:description" content="Migration vers Auth0 sans interruption : audit IAM, migration d'utilisateurs zéro downtime et expertise OAuth 2.0 / OIDC. Diagnostic gratuit en 3 minutes." />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* Background grid pattern */}
      <div className="fixed inset-0 grid-bg opacity-40 pointer-events-none" />
      
      {/* Gradient orbs for ambient lighting */}
      <div className="fixed top-0 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl opacity-20 pointer-events-none" />
      <div className="fixed bottom-0 right-1/4 w-96 h-96 bg-secondary/10 rounded-full blur-3xl opacity-20 pointer-events-none" />
      
      <div className="relative z-10">
        <Header scrolled={scrolled} onCTAClick={openWizard} />
        <main>
          <HeroSection onCTAClick={openWizard} />
          <PillarsSection />
          <SecurityProtocol />
          <WhyUsSection onCTAClick={openWizard} />
        </main>
        <Footer onCTAClick={openWizard} />
      </div>

      {/* Diagnostic Wizard Overlay */}
      <DiagnosticWizard isOpen={wizardOpen} onClose={closeWizard} />
    </div>
  );
}
